// Buttons.js
// Example: <Button type={"Primary"} ficon="user" text={ "Click me" } onpress={ callback } />
// Types: [ primary, secondary, successary, successary2, cautionary, cautionary2, ancillary, auxiliary, rudimentary, rudimentary2, link ]

import React, { useState } from "react";
import { Text, TouchableOpacity, View } from "react-native";
import { Feather } from "@react-native-vector-icons/feather";  // https://feathericons.com/?query=

// Primary Button Style
const Button = ({type, size="", ficon="", iconSize, iconStyle, text="Button", onpress=null, onPress=null, onMouseEnter=null, onMouseLeave=null, style={}, textStyle={}, hoverStyle={}, hoverTextStyle={}, width=-1, active=false, disabled=false, ...props}) => {
  const _wos = (window.main.platform_os === "web");
  const _theme = window.main.theme;
  const styles = {
    btn: {
      alignItems: "center",
      backgroundColor: window.main.theme.colors.mode.base,
      borderColor: window.main.theme.colors.mode.base,
      borderRadius: _theme.inputBorderRadius,
      borderWidth: 2,
      display: "flex",
      flexDirection: "row",
      height: 34,
      justifyContent: "center",
      marginVertical: 2,
      paddingHorizontal: 16,
      textAlign: "center"
    },
    btnText: {
      color: _theme.colors.white,
      fontSize: 16,
      fontWeight: "400",
    },
    disabledButtonOverlay: {
      backgroundColor: "rgba(190,190,190,0.4)",
      borderRadius: _theme.inputBorderRadius,
      bottom: -2,
      left: -2,
      margin: 0,
      padding: 0,
      position: "absolute",
      right: -2,
      top: -2,
    }
  };
  const [_isHover, _setIsHover] = useState(false);
  type = (!!type ? type.toLowerCase() : type);
  var override = {};
  switch (type) {
    case "link":
      override = {
        btn: {
          backgroundColor: "transparent",
          borderColor: "transparent",
        },
        btnHover: {
          backgroundColor: "transparent",
          borderColor: "transparent",
        },
        btnText: {
          color: _theme.colors.mode.base,
        },
        btnTextHover: {
          color: (props.hoverColor || _theme.colors.mode.baseHover),
        }
      };
      if (width === -1) {  // IF NOT SET
        width = "auto";
      }
      break;

    case "tab":
      override = {
        btn: {
          backgroundColor: _theme.colors.white,
          borderColor: (!!active?_theme.colors.mode.base:"transparent"),
          borderWidth: 1,
          borderBottomColor: (!!active?_theme.colors.white:"transparent"),
          marginVertical: 0,
        },
        btnHover: {
          backgroundColor: _theme.colors.white,
          borderColor: (!!active?_theme.colors.mode.base:"transparent"),
          borderWidth: 1,
          borderBottomColor: (!!active?_theme.colors.white:"transparent"),
          marginVertical: 0,
        },
        btnText: {
          color: _theme.colors.mode.base,
          fontWeight: (!!active?"600":"300"),
        },
        btnTextHover: {
          color: (props.hoverColor || _theme.colors.mode.baseHover),
          fontWeight: (!!active?"600":"300"),
        }
      };
      if (width === -1) {  // IF NOT SET
        width = "auto";
      }
      break;

    case "rudimentary":
      override = {
        btn: {
          backgroundColor: _theme.colors.monoMedium,
          borderColor: _theme.colors.monoMedium,
        },
        btnHover: {
          backgroundColor: _theme.colors.monoLight,
          borderColor: _theme.colors.monoLight,
        },
        btnText: {
          color: _theme.colors.monoBackground
        },
        btnTextHover: {
          color: _theme.colors.white
        }
      };
      break;

    case "rudimentary2":
      override = {
        btn: {
          backgroundColor: _theme.colors.white,
          borderColor: _theme.colors.monoMedium,
        },
        btnHover: {
          backgroundColor: _theme.colors.monoBackground,
          borderColor: _theme.colors.monoLight,
        },
        btnText: {
          color: _theme.colors.monoMedium
        },
        btnTextHover: {
          color: _theme.colors.monoLight
        }
      };
      break;

    case "successary":
      override = {
        btn: {
          backgroundColor: _theme.colors.success,
          borderColor: _theme.colors.success,
        },
        btnHover: {
          backgroundColor: _theme.colors.successMedium,
          borderColor: _theme.colors.successMedium,
        },
        btnText: {
          color: _theme.colors.successBackground
        },
        btnTextHover: {
          color: _theme.colors.white
        }
      };
      break;

    case "successary2":
      override = {
        btn: {
          backgroundColor: _theme.colors.white,
          borderColor: _theme.colors.success,
        },
        btnHover: {
          backgroundColor: _theme.colors.successBackground,
          borderColor: _theme.colors.successMedium,
        },
        btnText: {
          color: _theme.colors.success
        },
        btnTextHover: {
          color: _theme.colors.successMedium
        }
      };
      break;

    case "cautionary":
      override = {
        btn: {
          backgroundColor: _theme.colors.caution,
          borderColor: _theme.colors.caution,
        },
        btnHover: {
          backgroundColor: _theme.colors.cautionHover,
          borderColor: _theme.colors.cautionHover,
        },
        btnText: {
          color: _theme.colors.white
        },
        btnTextHover: {
          color: _theme.colors.white
        }
      };
      break;

    case "cautionary2":
      override = {
        btn: {
          backgroundColor: _theme.colors.white,
          borderColor: _theme.colors.caution,
        },
        btnHover: {
          backgroundColor: _theme.colors.cautionBackground,
          borderColor: _theme.colors.cautionHover,
        },
        btnText: {
          color: _theme.colors.caution
        },
        btnTextHover: {
          color: _theme.colors.cautionHover
        }
      };
      break;

    case "ancillary":
      override = {
        btn: {
          backgroundColor: _theme.colors.white,
          borderColor: _theme.colors.warn,
        },
        btnHover: {
          backgroundColor: _theme.colors.warnBackground,
          borderColor: _theme.colors.warnHover,
        },
        btnText: {
          color: _theme.colors.warn
        },
        btnTextHover: {
          color: _theme.colors.warnHover
        }
      };
      break;

    case "emphasary":
      override = {
        btn: {
          backgroundColor: _theme.colors.emphDark,
          borderColor: _theme.colors.emphDark,
        },
        btnHover: {
          backgroundColor: _theme.colors.emph,
          borderColor: _theme.colors.emph,
        },
        btnText: {
          color: _theme.colors.monoDark
        },
        btnTextHover: {
          color: _theme.colors.monoDark
        }
      };
      break;

    case "auxiliary":
      override = {
        btn: {
          backgroundColor: _theme.colors.auxiliary,
          borderColor: _theme.colors.auxiliary,
        },
        btnHover: {
          backgroundColor: _theme.colors.auxiliaryHover,
          borderColor: _theme.colors.auxiliaryHover,
        },
        btnText: {
          color: _theme.colors.white
        },
        btnTextHover: {
          color: _theme.colors.white
        }
      };
      break;

    case "secondary":
      override = {
        btn: {
          backgroundColor: _theme.colors.white,
          borderColor: _theme.colors.mode.base,
        },
        btnHover: {
          backgroundColor: _theme.colors.mode.baseBackground,
          borderColor: _theme.colors.mode.baseHover,
        },
        btnText: {
          color: _theme.colors.mode.base
        },
        btnTextHover: {
          color: _theme.colors.mode.baseHover
        }
      };
      break;

    case "primarylight":
      override = {
        btn: {
          backgroundColor: _theme.colors.mode.baseMedium,
          borderColor: _theme.colors.mode.baseMedium,
        },
        btnHover: {
          backgroundColor: _theme.colors.mode.baseHover,
          borderColor: _theme.colors.mode.baseHover,
        },
        btnText: {
          color: _theme.colors.white
        },
        btnTextHover: {
          color: _theme.colors.white
        }
      };
      break;

    case "primary":
    default:
      override = {
        btn: {
          backgroundColor: _theme.colors.mode.base,
          borderColor: _theme.colors.mode.base,
        },
        btnHover: {
          backgroundColor: _theme.colors.mode.baseHover,
          borderColor: _theme.colors.mode.baseHover,
        },
        btnText: {
          color: _theme.colors.white
        },
        btnTextHover: {
          color: _theme.colors.white
        }
      };
      break;
  };
  if (width === -1) {  // IF NOT SET
    width = 200;  // DEFAULT WIDTH!
  }

  let sizeAltStyle = {};
  let sizeAltTextStyle = {};
  if (size==="tiny"||size==="icon") {
    override.btn.borderWidth = 1;
    override.btnHover.borderWidth = 1;
    width = 18;
    sizeAltStyle = {
      alignItems:"flex-start",
      height: 18,
      width: 18,
    };
    sizeAltTextStyle = {
      fontSize: 12,
      lineHeight: 14,
    };
    if (!iconSize) {
      iconSize = (!!iconStyle&&!!iconStyle.fontSize?iconStyle.fontSize:_theme.sizes.icon.tiny);
    }
  } else if (size==="small") {
    sizeAltStyle = {
      alignItems:"flex-start",
      height: 22,
      width: 150,
    };
    sizeAltTextStyle = {
      fontSize: 14,
      lineHeight: 18,
    };
    if (!iconSize) {
      iconSize = (!!iconStyle&&!!iconStyle.fontSize?iconStyle.fontSize:_theme.sizes.icon.small);
    }
  } else if (size==="large") {
    sizeAltStyle = {
      height: 48,
      paddingHorizontal: 22,
    };
    sizeAltTextStyle = {
      fontSize: 20,
      lineHeight: 44,
    };
    if (!iconSize) {
      iconSize = (!!iconStyle&&!!iconStyle.fontSize?iconStyle.fontSize:_theme.sizes.icon.large);
    }
  } else if (!iconSize) {
    iconSize = (!!iconStyle&&!!iconStyle.fontSize?iconStyle.fontSize:_theme.sizes.icon.default);
  }

  const btnStyle = {
    ...styles.btn,
    ...( _isHover ? override.btnHover : override.btn ),
    ...{ width: width },
    ...sizeAltStyle,
    ...style,
    ...( _isHover ? hoverStyle : {} ),
  };

  const btnTextStyle = {
    ...styles.btnText,
    ...( _isHover ? override.btnTextHover : override.btnText ),
    ...sizeAltTextStyle,
    ...textStyle,
    ...( _isHover ? hoverTextStyle : {} ),
  };

  // Alterations
  /* iconSize=_theme.sizes.icon.default
    icon: {
      small: 14,
      default: 18,
      large: 22,
      xlarge: 26,
    }
  */

  const Inner = ()=>{
    if (!!props.children) {
      return (
        <>
          {props.children}
        </>
      );
    } else {
      return (
        <>
          {!!ficon && typeof(ficon)==="string" &&
            <Feather name={ficon} style={{fontSize:iconSize,...btnTextStyle,...iconStyle}} />
          }
          {size!=="icon" &&
            <Text numberOfLines={1} style={btnTextStyle}>
              {!!ficon && typeof(ficon)==="function" && ficon() }
              {!!ficon && !!text && !_wos && <Text>&nbsp;</Text> }
              {!!text && <Text style={{paddingLeft:(!!ficon?6:0)}}>{text}</Text> }
            </Text>
          }
          {!!disabled && <TouchableOpacity onPress={()=>{}} style={styles.disabledButtonOverlay} />}
        </>
      );
    }
  };

  return (
    <TouchableOpacity style={{position:"relative",zIndex:1,elevation:0,...btnStyle}} onPress={ onpress || onPress } onMouseEnter={() => { _setIsHover(!disabled); if(typeof(onMouseEnter)==="function"){onMouseEnter()} }} onMouseLeave={() => { _setIsHover(false); if(typeof(onMouseLeave)==="function"){onMouseLeave()} }} disabled={disabled} activeOpacity={0.7} {...props} accessibilityRole="button">
      <Inner />
      {type==="tab" && !!active &&
        <View id="lineCover" style={{flexDirection:"row",position:"absolute",bottom:-2,left:-5,right:-5,height:5,width:width,backgroundColor:_theme.colors.white,zIndex:2}}>
          <View id="lineCover" style={{flexDirection:"row",position:"absolute",bottom:0,left:-5,height:10,width:10,backgroundColor:_theme.colors.white,borderColor:_theme.colors.mode.base,borderWidth:1,borderRadius:_theme.inputBorderRadius,zIndex:3}}>
            <View id="lineCover" style={{flexDirection:"row",position:"absolute",bottom:0,right:0,height:15,width:15,backgroundColor:_theme.colors.white,borderRadius:_theme.inputBorderRadius}}></View>
          </View>
          <View id="lineCover" style={{flexDirection:"row",position:"absolute",bottom:0,right:-5,height:10,width:10,backgroundColor:_theme.colors.white,borderColor:_theme.colors.mode.base,borderWidth:1,borderRadius:_theme.inputBorderRadius,zIndex:3}}>
            <View id="lineCover" style={{flexDirection:"row",position:"absolute",bottom:0,left:0,height:15,width:15,backgroundColor:_theme.colors.white,borderRadius:_theme.inputBorderRadius}}></View>
          </View>
        </View>
      }
    </TouchableOpacity>
  );
};

const PrimaryButton = ({ficon, iconSize, text, onpress, width="100%", disabled}) => {
  var type = "primary";
  return Button({type, ficon, iconSize, text, onpress, width, disabled});
};

const SecondaryButton = ({ficon, iconSize, text, onpress, width="100%", disabled}) => {
  var type = "secondary";
  return Button({type, ficon, iconSize, text, onpress, width, disabled});
};

const AncillaryButton = ({ficon, iconSize, text, onpress, width="100%", disabled}) => {
  var type = "ancillary";
  return Button({type, ficon, iconSize, text, onpress, width, disabled});
};

const CautionaryButton = ({ficon, iconSize, text, onpress, width="100%", disabled}) => {
  var type = "cautionary";
  return Button({type, ficon, iconSize, text, onpress, width, disabled});
};

const CautionaryButton2 = ({ficon, iconSize, text, onpress, width="100%", disabled}) => {
  var type = "cautionary2";
  return Button({type, ficon, iconSize, text, onpress, width, disabled});
};

const RudimentaryButton = ({ficon, iconSize, text, onpress, width="100%", disabled}) => {
  var type = "rudimentary";
  return Button({type, ficon, iconSize, text, onpress, width, disabled});
};

const LinkButton = ({ficon, iconSize, text, onpress, width="auto", disabled}) => {
  var type = "link";
  return Button({type, ficon, iconSize, text, onpress, width, disabled});
};

export default Button;
export {
  PrimaryButton,
  SecondaryButton,
  AncillaryButton,
  CautionaryButton,
  CautionaryButton2,
  RudimentaryButton,
  LinkButton,
};
